import { User } from "models/User";

const getProfileLink = (data: User) => {
  if (data?.customDomainUrl) return `${data.customDomainUrl}`;
  if (data?.username) return `/${data.username}`;
  return "/";
};

export { getProfileLink };
